import { FormattedMessage } from 'react-intl';

type LiveContentWarningProps = {
  editing: boolean;
};

export default function LiveContentWarning({
  editing,
}: LiveContentWarningProps) {
  return editing ? (
    <div className="editing_live_warning">
      <FormattedMessage id="GENERAL.EDITING_LIVE_WARNING" />
    </div>
  ) : null;
}
